
const Stage = require('./stage');
const Production = require('./production');
const Developement = require('./dev');


const config = {
development:Developement,
stage: Stage,
production: Production,

};



const env = process.env.NODE_ENV || 'development';

config.env = env;

module.exports = config[env];